export default __webpack_public_path__ + "static/media/pangeanic-logo.aca1b0e6.png";